import { ICellRendererParams } from "@ag-grid-community/core";
import { Component, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";
import { FbmOrdersService } from "src/app/modules/fbm-orders/fbm-orders.service";

@Component({
  selector: "app-order-info-cell-renderer",
  templateUrl: "./order-info-cell-renderer.component.html",
  styleUrls: ["./order-info-cell-renderer.component.scss"],
})
export class OrderInfoCellRendererComponent implements OnDestroy {
  params: ICellRendererParams;
  private destroy$ = new Subject<void>();
  accountType: string;
  url: string;
  orderDetailUrl = {
    amazon: "https://sellercentral.amazon.com/orders-v3/order/",
    ebay: "https://ebay.com/sh/ord/details?orderid=",
    walmart: "http://seller.walmart.com/order-management/details?orderGroups=Unshipped&poNumber=",
  }

  constructor(private fbmOrderService:FbmOrdersService) {}

  agInit(params: ICellRendererParams): void {
    this.params = params;
    if (this.params.data.AccountType) {
      this.accountType = this.params.data.AccountType.toLowerCase();
    }
    if (this.accountType) { 
      this.url = this.orderDetailUrl[this.accountType];
    }
  }
  private _copy:boolean=false;
  get copied(): boolean{
    return this._copy;
  }

  set copied(value){
    this._copy=value;
    this.fbmOrderService.displayedProductModal.next(value?this.params.node:null);
  }

  copy(e) {
    this.copied = true;
    setTimeout(() => {
      this.copied = false;
    }, 800);
  }

  openLink(data) { 
    if (this.url) {
      let id;
      this.accountType == 'ebay' ? id = data.poid : id = data.Orderid;
      window.open(this.url + id);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
